// constants.js

export const placeholderImage = "https://zupimages.net/up/23/14/zdoe.jpg";
export const defaultBannerUrl = 'https://zupimages.net/up/23/35/57zz.png';
export const defaultAvatarUrl = 'https://zupimages.net/up/23/35/ppgw.jpg';
export const defaultUsername = "Nom d'utilisateur";
export const defaultEmail = "email@example.com";